import { render, staticRenderFns } from "./EmailsBlacklistPage.vue?vue&type=template&id=5926206e&scoped=true"
import script from "./EmailsBlacklistPage.vue?vue&type=script&lang=js"
export * from "./EmailsBlacklistPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5926206e",
  null
  
)

export default component.exports